module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previewer",
    attrs: {
      "id": "previewer-cover"
    },
    on: {
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.handleKeyup($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "cover"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCover),
      expression: "showCover"
    }],
    ref: "cover",
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "cover-top-bar"
  }, [_c('span', {
    staticClass: "serial"
  }, [_vm._v(_vm._s((parseInt(_vm.fakeIndex) + 1)) + " / " + _vm._s(_vm.loadedImages.length))]), _vm._v(" "), _c('span', {
    staticClass: "close-button tofu-icon icon-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadedImages.length > 1 && _vm.fakeIndex > 0),
      expression: "loadedImages.length > 1 && fakeIndex > 0"
    }],
    staticClass: "arrow tofu-icon icon-point-left",
    on: {
      "click": function($event) {
        _vm.switchImage('left')
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadedImages.length > 1 && _vm.fakeIndex < _vm.loadedImages.length - 1),
      expression: "loadedImages.length > 1 && fakeIndex < loadedImages.length - 1"
    }],
    staticClass: "arrow tofu-icon icon-point-right",
    on: {
      "click": function($event) {
        _vm.switchImage('right')
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadedImages[this.curImgIdx] && !_vm.loadedImages[this.curImgIdx].cached),
      expression: "loadedImages[this.curImgIdx] && !loadedImages[this.curImgIdx].cached"
    }],
    staticClass: "loading-image",
    attrs: {
      "src": _vm.loadedImages[this.curImgIdx] && _vm.loadedImages[this.curImgIdx].src,
      "alt": "图片加载失败"
    }
  }), _vm._v(" "), _vm._l((_vm.images), function(image, idx) {
    return _c('transition', {
      key: image.id,
      attrs: {
        "name": "scale",
        "css": true
      },
      on: {
        "enter": _vm.enter,
        "leave": _vm.leave,
        "afterLeave": _vm.afterLeave
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (image.id === _vm.curImgId && image.cached),
        expression: "image.id === curImgId && image.cached"
      }],
      staticClass: "preview-image",
      attrs: {
        "src": image.src,
        "data-idx": idx,
        "data-id": image.id
      },
      on: {
        "load": _vm.handleImageLoad
      }
    })])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-2b217e69!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/preview/src/preview.vue
// module id = 632
// module chunks = 0